var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetaStories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49987 0.533341C10.1568 0.533341 11.7668 1.08451 13.0761 2.10004C14.3854 3.11557 15.3197 4.53777 15.7318 6.14267C16.144 7.74756 16.0106 9.44397 15.3527 10.9647C14.6948 12.4855 13.5497 13.7442 12.0978 14.5426",
    stroke: "currentColor",
    strokeWidth: 1.03889,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15833 15.4376C7.78567 15.5591 6.40615 15.2984 5.17251 14.6843",
    stroke: "currentColor",
    strokeWidth: 1.03889,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97711 13.025C2.12279 12.086 1.52197 10.9447 1.23141 9.70899",
    stroke: "currentColor",
    strokeWidth: 1.03889,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14338 6.72204C1.28176 5.92547 1.5486 5.15667 1.93346 4.44566",
    stroke: "currentColor",
    strokeWidth: 1.03889,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7793 2.21491C4.05489 1.99003 4.34619 1.78514 4.65099 1.60179",
    stroke: "currentColor",
    strokeWidth: 1.03889,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.86658V10.1332",
    stroke: "currentColor",
    strokeWidth: 1.03889,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6338 8L6.36712 8",
    stroke: "currentColor",
    strokeWidth: 1.03889,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaStories);
export default __webpack_public_path__ + "static/media/metaStories.d0940a2e.svg";
export { ForwardRef as ReactComponent };